/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiComponents } from '../../models/AaiComponents';
import { Node } from '../../../core/models/Node';

/**
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {Node} parent
 * @class
 * @extends AaiComponents
 */
export class Aai20Components extends AaiComponents {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super(parent);
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
Aai20Components["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20Components";
Aai20Components["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




